import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import UserSideBar from '../../Components/User/UserSideBar'
import UserProfile from '../../Components/User/UserProfile';
const UserProfilePage = () => {
    return (
        <div className="cart-page-bg">
            <Container>
                <Row className='g-4 py-4'>
                    <Col lg="3" md="4" xs="12">
                        <UserSideBar />
                    </Col>
                    <Col lg="9" md="8" xs="12">
                        <UserProfile />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default UserProfilePage
